// extracted by mini-css-extract-plugin
export var stages = "style-module--stages--3277e";
export var stages__descriptionBlock = "style-module--stages__description-block--ed7f2";
export var stages__elDescription = "style-module--stages__el-description--a1bab";
export var stages__elTitle = "style-module--stages__el-title--75401";
export var stages__imgBlock = "style-module--stages__img-block--eaf2a";
export var stages__item = "style-module--stages__item--52305";
export var stages__list = "style-module--stages__list--429c8";
export var stages__number = "style-module--stages__number--743ec";
export var stages__title = "style-module--stages__title--cd49d";